import React from 'react';
import { Checkbox, Typography } from '@mui/material';
import { Grid } from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import { PercentSlider } from '@Components/PercentSlider';
import { useStyles } from './Component.styles';
import { MenuListButton } from '@innovyze/stylovyze';
import { useGlobalization } from '@Translations/useGlobalization';

export interface ComponentProps {
	title: string;
	subTitle?: string;
	value: number;
	disableSlider?: boolean;
	invalid?: boolean;
	onSliderValueChanged?: (value: number) => void;
	onSelectChecked?: (selected: boolean) => void;
	needMenu?: boolean;
	onEdit?: (title: string) => void;
	onDelete?: (title: string) => void;
	checkBox?: boolean;
	enabledChecked?: boolean;
}

export const Component = ({
	title,
	subTitle,
	value,
	disableSlider = false,
	invalid = false,
	onSliderValueChanged,
	onSelectChecked,
	needMenu = true,
	onEdit,
	onDelete,
	checkBox = false,
	enabledChecked,
}: ComponentProps) => {
	const { t } = useGlobalization();
	const classes = useStyles();

	const getLabel = () => (
		<Typography
			gutterBottom={subTitle != undefined}
			style={{
				marginLeft: '0px',
				fontWeight: 600,
				fontSize: '14px',
				lineHeight: '20px',
			}}>
			{title}
		</Typography>
	);

	return (
		<Grid container alignItems="center" className={classes.root}>
			<Grid item xs={2} container>
				<Grid item xs={12}>
					{getLabel()}
				</Grid>
				{subTitle ? (
					<Grid item xs={12}>
						<Typography
							gutterBottom
							style={{
								fontWeight: 400,
								fontSize: '10px',
								lineHeight: '12px',
								marginTop: '-7px',
							}}>
							{subTitle}
						</Typography>
					</Grid>
				) : (
					<></>
				)}
			</Grid>
			<Grid
				item
				xs={10}
				container
				justifyContent="space-between"
				style={{ paddingLeft: checkBox ? '18px' : '40px' }}>
				{checkBox ? (
					<div style={{ width: 'calc( 100% - 48px )' }}>
						<Checkbox
							disabled={disableSlider}
							checked={enabledChecked}
							onChange={(_: object, checked: boolean) => {
								if (onSelectChecked) onSelectChecked(checked);
							}}
						/>
					</div>
				) : (
					<div style={{ width: 'calc( 100% - 48px )' }}>
						<PercentSlider
							value={enabledChecked ? value : 0}
							onSliderChanged={onSliderValueChanged}
							disabled={disableSlider}
							invalid={invalid}
							marks={'minmaxticks'}
							valueLabelDisplay={'on'}
						/>
					</div>
				)}
				{needMenu ? (
					<MenuListButton
						menuItems={[
							{
								text: t('Edit'),
								icon: <Edit />,
								onClick: () => {
									if (onEdit) onEdit(title);
								},
							},
							{
								text: t('Delete'),
								icon: <Delete />,
								onClick: () => {
									if (onDelete) onDelete(title);
								},
							},
						]}
						buttonCy="actions"
					/>
				) : (
					<></>
				)}
			</Grid>
		</Grid>
	);
};
